module.exports = __webpack_public_path__ + "static/media/background.7125cda8.png";